import React, { useEffect } from 'react'

import { CreateTankComponentForm, CreateTankPageHeader } from '@/components/pages/Tanks/Create'
import { useDetergents } from '@/pages/Detergents/Detergent.hooks'
import { CreateTankRequest } from '@/types/apis/tanks/createTankRequest'

import { useCreateTank } from './Create.hooks'

const CreateTank = () => {
  const { loading, createTank } = useCreateTank()

  const { getAllDetergent, detergents } = useDetergents()

  useEffect(() => {
    getAllDetergent()
  }, [getAllDetergent])

  const handleSubmitForm = async (formValues: CreateTankRequest) => {
    await createTank({
      ...formValues,
      detergentIds: Array.isArray(formValues.detergentIds) ? formValues.detergentIds : [formValues.detergentIds],
    })
  }

  return (
    <>
      <CreateTankPageHeader />
      <CreateTankComponentForm {...{ loading, detergents }} onSubmit={handleSubmitForm} />
    </>
  )
}

CreateTank.displayName = 'CreateTank'
export default CreateTank
